module.exports = __webpack_public_path__ + "static/media/9DESA12.cc755317.jpg";